import { REALPERSON_ENV } from '../../constants/env';
import { TenantConfig } from '../types';

const realPersonEnvironment = REALPERSON_ENV === 'prod' ? 'prod' : 'staging';

const disclaimer = `# Hier können Sie Ihre medizinische Frage zu unseren Arzneimitteln stellen
Um fortzufahren, lesen Sie bitte unsere [Datenschutzerklärung](https://www.novartis.com/de-de/datenschutzerklaerung-des-medizinischen-infoservices) sowie die <code>Allgemeinen Nutzungsbedingungen</code>. Um fortzufahren, müssen Sie außerdem die folgende Einwilligung bestätigen:\n- Ich bestätige, dass ich mindestens 18 Jahre alt bin, und willige hiermit ein, dass Novartis die ggf. von mir im Rahmen der Anfrage angegebenen personenbezogenen Daten (einschließlich Gesundheitsdaten), die ich hier freiwillig mitteile, zum Zwecke der Beantwortung meiner Anfrage verarbeitet. Ich kann meine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.\n- Der **KI MedInfo Assistent** verwendet Künstliche Intelligenz (KI), um Ihre Fragen zu verstehen und passende Antworten bereitzustellen. Die Zuordnung der Antworten zu den von Ihnen gestellten Fragen basiert auf automatischer Verarbeitung. Bitte prüfen Sie daher wichtige Informationen gegebenenfalls selbst nach.\n- Ferner bestätige ich, dass es sich bei meiner Anfrage um eine allgemeine medizinische Fragestellung handelt, die keine Nebenwirkungsmeldung beinhaltet. Wenn Sie eine Nebenwirkung beobachtet haben, wenden Sie sich an Ihren Arzt. Wenn Sie diese Nebenwirkung schriftlich melden möchten, folgen Sie bitte diesem [Link](https://nebenwirkungen.bund.de).`;

const terms = `Die von Novartis auf dieser Seite bereitgestellten Inhalte basieren auf der gültigen Fachinformation des jeweiligen Arzneimittels und werden regelmäßig aktualisiert. Sie dienen allein der Information und stellen keine patienten-spezifische medizinische oder produktbezogene Empfehlung oder Beurteilung dar. Ausschließlich Ihr Arzt kann beurteilen, welche Behandlung und Produkte für Sie angemessen sind. Die hier bereitgestellten Inhalte ersetzen keine ärztliche Untersuchung oder Aufklärung und stellen keine Information über eine medizinische Diagnose oder Behandlung dar. Bitte wenden Sie sich umgehend an Ihren Arzt, falls Sie medizinischen Rat benötigen. Wenn Sie eine Nebenwirkung, auch bekannt unter der Bezeichnung "Unerwünschte Arzneimittelwirkungen (UAW)", beobachtet haben, wenden Sie sich an Ihren Arzt. Wenn Sie diese schriftlich melden möchten, nutzen Sie bitte diesen [Link](https://nebenwirkungen.bund.de). Sehen Sie dringend davon ab, UAW oder Nebenwirkungen über den **KI MedInfo Assistenten** zu melden.`;

const medicalInfo = `Novartis Pharma GmbH  \nMedizinischer InfoService  \nMo. - Fr. von 8 - 18 Uhr  \nTel: [+49 (0) 911 273 12 100](tel:004991127312100)  \nLive Chat: [https://chat.novartis.de](https://chat.novartis.de)  \nE-Mail: [infoservice.novartis@novartis.com](mailto:infoservice.novartis@novartis.com)\n\n[https://infoservice.novartis.de](https://infoservice.novartis.de)`;

export const novartisConfig: TenantConfig = {
  id: 'novartis',
  label: 'Novartis',
  deploymentTargets: {
    dev: 'https://novartis-app-dev.xircle.com',
    staging: 'https://novartis-app-staging.xircle.com',
    prod: 'https://novartis-app.xircle.com',
  },
  instances: [
    {
      id: 'novartis',
      label: 'Novartis',
      i18nNamespace: 'novartis',
      themeName: 'novartis',
      topics: [],
      isDefault: true,
      consentStorage: 'local',
      useMaxHeight: false,
      showResetChatButton: false,
      theme: {
        tokens: {
          main: '222 100% 20%',
          secondary: '207 95% 34%',
          soft: '240 8% 95%',
        },
        classes: {
          layout: {
            container:
              'rounded-2xl border-[#d8d8dc] bg-[#F2F2F4] shadow-[0_16px_42px_rgba(0,32,104,0.12)]',
            headerAccent: 'hidden',
            headerTitle: 'text-[24px] font-semibold text-[#002068]',
            headerSubtitle: 'text-[#002068]',
          },
          chat: {
            userMessage:
              'rounded-xl bg-[hsl(var(--xircle-secondary))] text-white shadow-[0_8px_22px_rgba(4,96,169,0.18)]',
            responseMessage: 'rounded-xl border-[#d8e3ef] bg-white text-[#13233a]',
            followUpButton: 'bg-[#0460A9] text-white hover:bg-[#002068]',
            alternativeButton: 'bg-[#002068] text-white hover:bg-[#0460A9]',
            thumbsDown: 'text-[#002068] hover:text-[#0460A9]',
          },
          input: {
            textarea: 'text-[#13233a]',
            placeholder: 'text-[#0460A9]',
          },
          consent: {
            background: 'bg-[#002068]',
          },
        },
      },
      content: {
        disclaimer,
        terms,
        medicalInfo,
      },
      liveChat: {
        realPerson: {
          enabled: true,
          environment: realPersonEnvironment,
          chatType: 'headless',
          targets: {
            staging: {
              host: 'https://staging720.realperson.de',
              departmentId: 20,
            },
            prod: {
              host: 'https://chat720.realperson.de',
              departmentId: 20,
            },
          },
        },
      },
    },
  ],
};
